const configsData = require('./configsData.json')
const mockAppDetails = require('./appData.json')
const mockDocument = require('./mockDocument.json')
const mockSearchDocuments = require('./searchDocuments.json')
const searchResultsData = require('./searchResultsData.json')
const reviewersData = require('./reviewers.json');
const { convertIsoToLocale } = require('../../styles/util')

const mockEndpoints = {
  studentDetails: {
    queryFn: (parameters) => {
      //parameters will be whatever is passed into your hook
      const { applicantEmployeeId, group, term } = parameters;
      //console.log("mockAppDetails", mockAppDetails)
      const filteredData = mockAppDetails.find(
        (item) =>
          item.applicantEmployeeId === applicantEmployeeId &&
          item.group?.key === group &&
          item.admitTerm.key === term
      );
      // Query Fn is what we are using to build the api.
      // queryFn docs: https://redux-toolkit.js.org/rtk-query/usage/customizing-queries#customizing-queries-with-queryfn
      const sampleApiResponse = {
          //RTK, when successful, always has a data property that is returned from the queryFn promise
          data: filteredData //the property here is based on what you expect your schema to be shaped like.
          //In this example, my schema.graphql file has a getStudentOrganizations within its Query
          //The data and property should be as close as possible to the expectation of the API to make for an easier transition later.      
      };
      const overridePromise = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(sampleApiResponse);
        }, 300); //Setting this as a timeout to simulate what the api call may be like
      });
      //Since this is just an override of the queryFn, you can also mimic errors. graphql still sends a 200 over, you can expect something like this:
    //   const errorSample = {
    //         "data": null,
    //         "errors": [
    //             {
    //               "path": null,
    //               "locations": [
    //                   {
    //                     "line": 10,
    //                     "column": 5,
    //                     "sourceName": null
    //                   }
    //                 ],
    //                   "message": "Validation error of type FieldUndefined: Field 'carer' in type 'StudentOrganization' is undefined @ 'getStudentOrganizations/carer'"
    //             }
    //           ]
    //   } 
       //in that case you would just return the errorSample instead of overridePromise

      return overridePromise;
    },
  },
  applicationDocuments: {
    queryFn: () => {
      const sampleApiResponse = {
        data: {
          getDocuments: mockDocument, 
        },
      };
      
      const overridePromise = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(sampleApiResponse);
        }, 300); //Setting this as a timeout to simulate what the api call may be like
      });
      //Since this is just an override of the queryFn, you can also mimic errors. graphql still sends a 200 over, you can expect something like this:
    //   const errorSample = {
    //         "data": null,
    //         "errors": [
    //             {
    //               "path": null,
    //               "locations": [
    //                   {
    //                     "line": 10,
    //                     "column": 5,
    //                     "sourceName": null
    //                   }
    //                 ],
    //                   "message": "Validation error of type FieldUndefined: Field 'carer' in type 'StudentOrganization' is undefined @ 'getStudentOrganizations/carer'"
    //             }
    //           ]
    //   } 
       //in that case you would just return the errorSample instead of overridePromise

      return overridePromise;
    },
  },
  documentFiles: {
    queryFn: () => {
      const sampleApiResponse = {
        data: {
          searchDocuments: mockSearchDocuments, 
        },
      };
      
      const overridePromise = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(sampleApiResponse);
        }, 300); //Setting this as a timeout to simulate what the api call may be like
      });
      //Since this is just an override of the queryFn, you can also mimic errors. graphql still sends a 200 over, you can expect something like this:
    //   const errorSample = {
    //         "data": null,
    //         "errors": [
    //             {
    //               "path": null,
    //               "locations": [
    //                   {
    //                     "line": 10,
    //                     "column": 5,
    //                     "sourceName": null
    //                   }
    //                 ],
    //                   "message": "Validation error of type FieldUndefined: Field 'carer' in type 'StudentOrganization' is undefined @ 'getStudentOrganizations/carer'"
    //             }
    //           ]
    //   } 
       //in that case you would just return the errorSample instead of overridePromise

      return overridePromise;
    },
  },

    search: {
        queryFn: async (searchParam) => {
            if (!(searchParam?.length > 0)) { return { data: undefined }; }
            
            let filteredResults = [];
            
            if (isNaN(searchParam)) { // Reviewers
                filteredResults = searchResultsData.data.getSearchResults?.filter(filterByReviewer.bind(searchParam))
            } else { // Appls
                filteredResults = searchResultsData.data.getSearchResults?.filter(filterByApplication.bind(searchParam))
            }

            const finalResult = { data: filteredResults };
            return await getDelayedResponse(finalResult, 300);
        }
    },

    getReviewers: {
        queryFn: function() {
            const data = reviewersData.data.getReviewers;
            return getDelayedResponse({ data }, 300);
        }
    },
    updateActiveReviewers: {
        queryFn: function (employeeIds, programGroup, activate) {
            console.info("Saving", employeeIds, programGroup, activate);
            return getDelayedResponse({ data: "success" }, 1500);
        }
    },
  configs: {
    queryFn: async () => {
      //   const response = await client.graphql({
      //     query: getDashboardData,
      //   });
      // return { data: response.data.getDashboardData }
      const sampleApiResponse = {
        data: {
          getConfigsData: configsData,
        },
      };

      const overridePromise = await new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(sampleApiResponse.data.getConfigsData);
        }, 300); //Setting this as a timeout to simulate what the api call may be like
      });

      // eslint-disable-next-line
      const errorSample = {
        "data": null,
        "errors": [
          {
            "path": null,
            "locations": [
              {
                "line": 10,
                "column": 5,
                "sourceName": null
              }
            ],
            "message": "Error retreiving configs data."
          }
        ]
      }

      return { data: overridePromise }
    },
  },
  updateConfig: {
    queryFn: async (input) => {
        const { rubric } = input
        const finalResult = { data: { rubric } }
        return await getDelayedResponse(finalResult, 300)
    },
  },
  setActiveRubric: {
    queryFn: async (input) => {
        const { rubric } = input
        const newRubric = structuredClone(rubric)
        newRubric.isActive = true
        const finalResult = { data: { rubric: newRubric } }
        return await getDelayedResponse(finalResult, 300)
    },
  },
  getStudentDashboardData: {
    queryFn: async () => {
        const studentStatus = {
          program: 'Honors',
          submittedDate: convertIsoToLocale('2025-01-05T14:48:00.000Z'),
          status: 'Pending',
        }
        const finalResult = { data: studentStatus }
        return await getDelayedResponse(finalResult, 300)
    },
  },
};

function filterByReviewer(item) {
    const searchParam = this.toLowerCase();
    if (item.type !== "Reviewer") { return false; }
    return item.firstName.toLowerCase().includes(searchParam) || item.lastName.toLowerCase().includes(searchParam);
}

function filterByApplication(item) {
    const searchParam = this.toLowerCase();
    if (item.type !== "Application") { return false; }
    return item.applicantEmployeeId === searchParam;
}

// Return a given response after delayMs milliseconds
async function getDelayedResponse(response, delayMs) {
    return new Promise(resolve => { setTimeout(() => resolve(response), delayMs); });
}

module.exports = { mockEndpoints };